<template>
  <div class="validation-field">
    <b-field
      :label="label"
      :type="type"
      :message="message"
      :custom-class="sizeClass"
      @focus="focussed">
      <slot></slot>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'ValidtionField',
  props: {
    label: { default: '' },
    validation: { default: null },
    sizeClass: { default: 'is-small' }
  },
  computed: {
    isValid () {
      return !(this.validation && this.validation.msg && this.validation.msg.length)
    },
    type () {
      return this.isValid ? '' : 'is-danger'
    },
    message () {
      return this.isValid ? '' : this.validation.msg
    }
  },
  methods: {
    focussed () {
      if (this.validation) {
        this.validation.msg = ''
      }
    }
  }
}
</script>

<style>
  .validation-field {
    margin-bottom: 15px;
  }
</style>
